import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { Layout } from '@storable/canaveral-components';
import Authorization from 'web/containers/Authorization';
import AuthHeartbeat from 'web/components/AuthHeartbeat';
import EchoNotifications from '../../../../admin/components/EchoNotifications';
import WelcomeModal from '../../../../admin/containers/WelcomeModal';
import AdminUnauthorized from './AdminUnauthorized';
import styles from './AdminLayout.scss';
import useFlipper from '../../../../modules/react/hooks/useFlipper';
import { FLIPPER_VOYAGER_WELCOME_MODAL } from '../../../../constants/flippers';
import config from '../../../web/config';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  header: PropTypes.node.isRequired,
  navbar: PropTypes.node.isRequired,
};

const defaultProps = {
  children: undefined,
};

const { app: { title: adminPostfix } } = config;
const AdminLayout = ({ children, header, navbar }) => {
  const welcomeModalEnabled = useFlipper(FLIPPER_VOYAGER_WELCOME_MODAL);

  return (
    <div className={styles.layout}>
      <Helmet
        titleTemplate={`%s | ${adminPostfix}`}
        meta={[
          { name: 'robots', content: 'noindex' },
        ]}
      />

      {/* Listen for changes to the authentication status */}
      <AuthHeartbeat />

      <Authorization>
        {authorized => (authorized ? (
          <Layout header={header} navbar={navbar}>
            <EchoNotifications />
            <Authorization requireHyper>
              {hyper => (
                !hyper && welcomeModalEnabled && <WelcomeModal />
              )}
            </Authorization>
            {children}
          </Layout>
        ) : (
          <AdminUnauthorized />
        ))}
      </Authorization>
    </div>
  );
};

AdminLayout.propTypes = propTypes;
AdminLayout.defaultProps = defaultProps;

export default AdminLayout;
